<template>
  <div id="app">
    <cephalon></cephalon>
    <el-scrollbar class="page-body">
      <router-view></router-view>
    </el-scrollbar>
  </div>
</template>

<script>
import Cephalon from "../components/Head.vue";
import { Notification } from 'element-ui';

export default {
  name: "app",
  components: {
    cephalon: Cephalon
  },
  beforeCreate() {
    if(!!window.ActiveXObject || "ActiveXObject" in window) {
      Notification.warning({
        title: '提示',
        message: '浏览器不兼容，可能出现网页打开失败、图片加载不全等问题，建议使用谷歌浏览器',
        customClass: 'browser-warning',
        duration: 0,
        showClose: false
      });
    }
  }
};
</script>

<style lang="less">
  @deep: ~'>>>';
*{
  box-sizing: border-box;
}
body,
html {
  padding: 0;
  margin: 0;
  background-color: #fff;
  overflow: hidden;
  .el-scrollbar {
    overflow: hidden;
    width: 100%;
    height: 100%;
    position: relative;
    @{deep} .el-scrollbar__wrap {
      overflow-y: scroll;
      overflow-x: hidden;
      height: 100%;
    }
  }
  .browser-warning {
    height: 128px;
  }
}

#app {
  height: 100vh;
  min-width: 860px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.page-body {
  flex: 1;
  overflow: hidden;
  margin-bottom: 0;
  height: calc(100% - 60px);
  & /deep/ .el-scrollbar__wrap {
    overflow: auto;
  }
}
/*.page-body>.el-scrollbar__wrap {*/
  /*overflow-x: auto;*/
/*}*/
.loadcss {
  background-color: rgba(0, 0, 0, 0.6);
}

  .el-scrollbar__wrap {
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// src/views/App.vue